var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-pin-resend"},[_c('confirmation-content',[_c('div',{staticClass:"confirmation-content__title"},[_vm._v("Poszło!")]),_c('div',{staticClass:"confirmation-content__subtitle"},[_vm._v(" Wysłaliśmy do Ciebie kod dostępu. ")]),_c('div',[_vm._v("Nie doszło? Sprawdź folder Spam lub Oferty.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }